(function () {
  'use strict';

  function loadI18n() {
    var el = document.getElementById('bb-mobile-nav-i18n');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return {};
    }
  }

  var i18n = loadI18n();

  var titleKeys = {
    skin: 'skin',
    hair: 'hair',
    body: 'body',
    'baby-maternity': 'baby_maternity',
    'beauty-devices': 'beauty_devices',
    fragrance: 'fragrance',
    brands: 'brands'
  };

  function loadTaxonomy() {
    var el = document.getElementById('bb-mobile-nav-taxonomy');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return {};
    }
  }

  function buildCategories() {
    var taxonomy = loadTaxonomy();
    var categories = {};

    Object.keys(taxonomy).forEach(function (key) {
      var tabs = (taxonomy[key].tabs || []).filter(function (tab) {
        return tab.links && tab.links.length > 0;
      });
      if (tabs.length === 0) return;

      var titleKey = titleKeys[key] || key;
      categories[key] = {
        title: i18n[titleKey] || key,
        tabs: tabs
      };
    });

    return categories;
  }

  var categories = buildCategories();

  var featureData = {};
  var navEl = null;
  var activeCategoryKey = null;
  var activeTabIndex = 0;
  var shopByOpen = false;
  var featureTimer = null;

  function loadFeatureData() {
    var dataEl = document.getElementById('bb-mobile-nav-data');
    if (!dataEl) return;
    try {
      featureData = JSON.parse(dataEl.textContent);
    } catch (err) {
      featureData = {};
    }
  }

  function getShopByEls() {
    return {
      wrap: document.getElementById('bb-mobile-nav-shop-by'),
      trigger: document.getElementById('bb-mobile-nav-shop-by-trigger'),
      label: document.getElementById('bb-mobile-nav-shop-by-label'),
      menu: document.getElementById('bb-mobile-nav-shop-by-menu')
    };
  }

  function setShopByOpen(isOpen) {
    var els = getShopByEls();
    shopByOpen = !!isOpen;
    if (els.trigger) els.trigger.setAttribute('aria-expanded', shopByOpen ? 'true' : 'false');
    if (els.wrap) els.wrap.classList.toggle('is-open', shopByOpen);
    if (els.menu) els.menu.hidden = !shopByOpen;
  }

  function stopFeatureRotation() {
    if (!featureTimer) return;
    clearInterval(featureTimer);
    featureTimer = null;
  }

  function renderFeatured(key) {
    stopFeatureRotation();
    var featured = document.getElementById('bb-mobile-nav-featured');
    var rotator = document.getElementById('bb-mobile-nav-rotator');
    var data = featureData[key] || {};
    var products = data.products || [];

    if (!featured || !rotator) return;

    rotator.innerHTML = '';
    if (!products.length) {
      rotator.hidden = true;
      featured.hidden = false;
      return;
    }

    products.forEach(function (product) {
      var link = document.createElement('a');
      link.className = 'bb-mobile-nav__spot';
      link.href = product.url || '#';
      link.hidden = true;

      var media = document.createElement('span');
      media.className = 'bb-mobile-nav__spot-image';
      if (product.image) {
        var img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title || '';
        img.width = 280;
        img.height = 280;
        media.appendChild(img);
      }
      link.appendChild(media);

      var eyebrow = document.createElement('span');
      eyebrow.className = 'bb-mobile-nav__spot-eyebrow text-label-caps';
      eyebrow.textContent = i18n.bestsellers || 'Bestsellers';
      link.appendChild(eyebrow);

      if (product.brand) {
        var brand = document.createElement('span');
        brand.className = 'bb-mobile-nav__spot-brand';
        brand.textContent = product.brand;
        link.appendChild(brand);
      }

      var name = document.createElement('span');
      name.className = 'bb-mobile-nav__spot-name';
      name.textContent = product.title || '';
      link.appendChild(name);

      if (product.size) {
        var size = document.createElement('span');
        size.className = 'bb-mobile-nav__spot-size';
        size.textContent = product.size;
        link.appendChild(size);
      }

      if (product.description) {
        var desc = document.createElement('span');
        desc.className = 'bb-mobile-nav__spot-desc';
        desc.textContent = product.description;
        link.appendChild(desc);
      }

      rotator.appendChild(link);
    });

    var slides = rotator.querySelectorAll('.bb-mobile-nav__spot');
    var index = Math.floor(Math.random() * slides.length);

    function show(next) {
      index = next;
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.classList.toggle('is-active', on);
        slide.hidden = !on;
      });
    }

    show(index);
    rotator.hidden = false;
    featured.hidden = false;

    if (slides.length < 2) return;
    featureTimer = setInterval(function () {
      show((index + 1) % slides.length);
    }, 4500);
  }

  function renderLinks(links) {
    var list = document.getElementById('bb-mobile-nav-links');
    if (!list) return;
    list.innerHTML = '';

    (links || []).forEach(function (item) {
      var link = document.createElement('a');
      link.className = 'bb-mobile-nav__category-link';
      link.href = item.url || '#';
      link.textContent = item.label || '';
      list.appendChild(link);
    });
  }

  function selectTab(tabIndex) {
    var config = categories[activeCategoryKey];
    if (!config || !config.tabs[tabIndex]) return;

    activeTabIndex = tabIndex;
    var tab = config.tabs[tabIndex];
    var els = getShopByEls();

    if (els.label) els.label.textContent = tab.label;
    setShopByOpen(false);
    renderLinks(tab.links);

    if (els.menu) {
      els.menu.querySelectorAll('[role="option"]').forEach(function (option, index) {
        var isActive = index === tabIndex + 1; // +1 because Shop all is first
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
        option.classList.toggle('is-active', isActive);
      });
    }
  }

  function renderShopByDropdown(key, tabs) {
    var els = getShopByEls();
    var data = featureData[key] || {};
    if (!els.menu || !els.label || !els.trigger) return;

    els.menu.innerHTML = '';

    // First option: Shop all [Category]
    var shopAllOption = document.createElement('li');
    shopAllOption.setAttribute('role', 'option');
    shopAllOption.className = 'bb-mobile-nav__shop-by-option bb-mobile-nav__shop-by-option--shop-all';

    var shopAllLink = document.createElement('a');
    shopAllLink.className = 'bb-mobile-nav__shop-by-option-btn';
    shopAllLink.href = data.shopAllUrl || '#';
    shopAllLink.textContent = data.shopAllLabel || ('Shop all ' + (categories[key] && categories[key].title ? categories[key].title : ''));
    shopAllOption.appendChild(shopAllLink);
    els.menu.appendChild(shopAllOption);

    tabs.forEach(function (tab, tabIndex) {
      var option = document.createElement('li');
      option.setAttribute('role', 'option');
      option.className = 'bb-mobile-nav__shop-by-option';
      option.setAttribute('aria-selected', tabIndex === 0 ? 'true' : 'false');
      if (tabIndex === 0) option.classList.add('is-active');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bb-mobile-nav__shop-by-option-btn';
      button.textContent = tab.label;
      button.addEventListener('click', function () {
        selectTab(tabIndex);
      });

      option.appendChild(button);
      els.menu.appendChild(option);
    });

    activeTabIndex = 0;
    els.label.textContent = tabs[0] ? tabs[0].label : 'Shop by';
    setShopByOpen(false);
    renderLinks(tabs[0] ? tabs[0].links : []);
  }

  function setSubOpen(isOpen) {
    if (!navEl) return;
    var subPanel = document.getElementById('bb-mobile-nav-sub');

    if (isOpen) {
      navEl.classList.add('is-sub-open');
      if (subPanel) subPanel.setAttribute('aria-hidden', 'false');
    } else {
      navEl.classList.remove('is-sub-open');
      if (subPanel) subPanel.setAttribute('aria-hidden', 'true');
      setShopByOpen(false);
    }
  }

  function openCategory(key) {
    var config = categories[key];
    if (!config) return;

    activeCategoryKey = key;

    var title = document.getElementById('bb-mobile-nav-title');
    if (title) title.textContent = config.title;
    renderFeatured(key);
    renderShopByDropdown(key, config.tabs);
    setSubOpen(true);

    var scroll = document.querySelector('#bb-mobile-nav-sub .bb-mobile-nav__panel-scroll');
    if (scroll) scroll.scrollTop = 0;
  }

  function resetPanels() {
    stopFeatureRotation();
    setSubOpen(false);
    activeCategoryKey = null;
  }

  function initMobileNav() {
    navEl = document.getElementById('mobile-menu');
    loadFeatureData();

    var backBtn = document.getElementById('bb-mobile-nav-back');
    if (backBtn) {
      backBtn.addEventListener('click', resetPanels);
    }

    var els = getShopByEls();
    if (els.trigger) {
      els.trigger.addEventListener('click', function () {
        setShopByOpen(!shopByOpen);
      });
    }

    document.addEventListener('click', function (event) {
      var wrap = document.getElementById('bb-mobile-nav-shop-by');
      if (!shopByOpen || !wrap) return;
      if (!wrap.contains(event.target)) {
        setShopByOpen(false);
      }
    });

    document.querySelectorAll('[data-bb-mobile-category]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openCategory(trigger.getAttribute('data-bb-mobile-category'));
      });
    });
  }

  window.BBMobileNav = {
    reset: resetPanels
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNav);
  } else {
    initMobileNav();
  }
})();
